// extracted by mini-css-extract-plugin
module.exports = {"free-color":"#4ca9ed","plus-color":"#f99aa7","pro-color":"#29a877","premium-color":"#eb114c","general-color":"#d3e3f4","font-color":"#fff","disabled-color":"#777"};